<template>
    <ToolbarDropdown :is-locked="isLocked">
        <template v-slot:toggle>
            <img src="/default-images/whiteboard/tool-multiline-arrow.svg" />
        </template>
        <div class="bg-white p-1 flex gap-2 items-center justify-center">
            <div class="toolbar-group">
                <button
                    type="button"
                    @click="currentTool = 'lineAcross'"
                    :class="{ active: currentTool == 'lineAcross' }"
                >
                    <img
                        src="/default-images/whiteboard/tool-line-across.svg"
                        width="30"
                        height="30"
                    />
                </button>
            </div>
            <div class="toolbar-group">
                <button
                    type="button"
                    @click="currentTool = 'multiline'"
                    :class="{ active: currentTool == 'multiline' }"
                >
                    <img
                        src="/default-images/whiteboard/tool-multiline.svg"
                        width="30"
                        height="30"
                    />
                </button>
                <button
                    type="button"
                    @click="currentTool = 'multilineArrow'"
                    :class="{ active: currentTool == 'multilineArrow' }"
                >
                    <img
                        src="/default-images/whiteboard/tool-multiline-arrow.svg"
                        width="30"
                        height="30"
                    />
                </button>
                <button
                    type="button"
                    @click="currentTool = 'multilineHammer'"
                    :class="{ active: currentTool == 'multilineHammer' }"
                >
                    <img
                        src="/default-images/whiteboard/tool-multiline-hammer.svg"
                        width="30"
                        height="30"
                    />
                </button>
            </div>
            <div class="sep"></div>
            <div class="toolbar-group">
                <button
                    type="button"
                    @click="currentTool = 'pen'"
                    :class="{ active: currentTool == 'pen' }"
                >
                    <img src="/default-images/whiteboard/tool-pen.svg" />
                </button>
                <button
                    type="button"
                    @click="currentTool = 'penArrow'"
                    :class="{ active: currentTool == 'penArrow' }"
                >
                    <img
                        src="/default-images/whiteboard/tool-pen-arrow.svg"
                        width="35"
                    />
                </button>
                <button
                    type="button"
                    @click="currentTool = 'bezierLine'"
                    :class="{ active: currentTool == 'bezierLine' }"
                >
                    <img
                        src="/default-images/whiteboard/tool-bezier-line.svg"
                        width="30"
                    />
                </button>
                <button
                    type="button"
                    @click="currentTool = 'bezierLineTab'"
                    :class="{ active: currentTool == 'bezierLineTab' }"
                >
                    <img
                        src="/default-images/whiteboard/tool-bezier-line-tab.svg"
                        width="30"
                    />
                </button>
                <button
                    type="button"
                    @click="currentTool = 'penTab'"
                    :class="{ active: currentTool == 'penTab' }"
                >
                    <img
                        src="/default-images/whiteboard/tool-pen-tab.svg"
                        width="35"
                    />
                </button>
                <template v-if="props.sport == 'american-football'">
                    <button
                        type="button"
                        @click="currentTool = 'penSquigglyFirstArrow'"
                        :class="{
                            active: currentTool == 'penSquigglyFirstArrow',
                        }"
                    >
                        <img
                            src="/default-images/whiteboard/tool-pen-squiggly-arrow.webp"
                        />
                    </button>
                    <button
                        type="button"
                        @click="currentTool = 'penSquigglyFirstTab'"
                        :class="{
                            active: currentTool == 'penSquigglyFirstTab',
                        }"
                    >
                        <img
                            src="/default-images/whiteboard/tool-pen-squiggly-tab.webp"
                        />
                    </button>
                </template>
                <template v-else>
                    <button
                        type="button"
                        @click="currentTool = 'penSquigglyArrow'"
                        :class="{ active: currentTool == 'penSquigglyArrow' }"
                    >
                        <img
                            src="/default-images/whiteboard/tool-pen-squiggly-arrow.webp"
                        />
                    </button>
                    <button
                        type="button"
                        @click="currentTool = 'penSquigglyTab'"
                        :class="{ active: currentTool == 'penSquigglyTab' }"
                    >
                        <img
                            src="/default-images/whiteboard/tool-pen-squiggly-tab.webp"
                        />
                    </button>
                </template>
            </div>
            <div class="sep"></div>
            <div class="toolbar-group">
                <button
                    type="button"
                    @click="currentTool = 'multilineDotted'"
                    :class="{
                        active: currentTool == 'multilineDotted',
                    }"
                >
                    <img
                        src="/default-images/whiteboard/tool-multiline-dashed.svg"
                        width="30"
                        height="30"
                    />
                </button>

                <button
                    type="button"
                    @click="currentTool = 'multilineDashedArrow'"
                    :class="{
                        active: currentTool == 'multilineDashedArrow',
                    }"
                >
                    <img
                        src="/default-images/whiteboard/tool-multiline-dashed-arrow.svg"
                        width="30"
                        height="30"
                    />
                </button>
            </div>
            <div class="sep"></div>
            <div class="toolbar-group">
                <button
                    type="button"
                    @click="currentTool = 'penDotted'"
                    :class="{ active: currentTool == 'penDotted' }"
                >
                    <img src="/default-images/whiteboard/tool-pen-dotted.svg" />
                </button>
                <button
                    type="button"
                    @click="currentTool = 'penDottedArrow'"
                    :class="{ active: currentTool == 'penDottedArrow' }"
                >
                    <img
                        src="/default-images/whiteboard/tool-pen-dotted-arrow.svg"
                        width="35"
                    />
                </button>

                <button
                    type="button"
                    @click="currentTool = 'bezierLineDashed'"
                    :class="{ active: currentTool == 'bezierLineDashed' }"
                >
                    <img
                        src="/default-images/whiteboard/tool-bezier-line-dashed.svg"
                        width="30"
                    />
                </button>

                <button
                    type="button"
                    @click="currentTool = 'bezierLineTabDashed'"
                    :class="{ active: currentTool == 'bezierLineTabDashed' }"
                >
                    <img
                        src="/default-images/whiteboard/tool-bezier-line-tab-dashed.svg"
                        width="30"
                    />
                </button>
            </div>
        </div>
    </ToolbarDropdown>
</template>

<script setup>
import useWhiteboard from "../useWhiteboard";
const { currentTool, isLocked } = useWhiteboard();
import { defineProps } from "vue";
const props = defineProps(["sport"]);
</script>
